{
  "about.blocks": "മോഡറേറ്റഡ് സെർവറുകൾ",
  "about.contact": "ബന്ധപ്പെടുക:",
  "about.domain_blocks.no_reason_available": "കാരണം ലഭ്യമല്",
  "about.domain_blocks.silenced.title": "പരിമിതമായത്",
  "about.domain_blocks.suspended.title": "താൽക്കാലികമായി നിർത്തിവെച്ചിരിക്കുന്നു",
  "about.rules": "സെർവ്വർ നിയമങ്ങൾ",
  "account.account_note_header": "സ്വകാര്യ കുറിപ്പു്",
  "account.add_or_remove_from_list": "പട്ടികയിൽ ചേർക്കുകയോ/മാറ്റുകയോ ചെയ്യുക",
  "account.badges.bot": "റോബോട്ട്",
  "account.badges.group": "ഗ്രൂപ്പ്",
  "account.block": "@{name} -നെ തടയുക",
  "account.block_domain": "{domain} എന്ന മേഖല തടയുക",
  "account.block_short": "തടസ്സപെടുത്തുക",
  "account.blocked": "തടഞ്ഞു",
  "account.cancel_follow_request": "Withdraw follow request",
  "account.copy": "രൂപരേഖയിന്റെ വിലാസം പകർത്തുക",
  "account.direct": "സ്വകാരൃമായിട്ടു് @{name}-ന് സൂചനപിക്കുക",
  "account.disable_notifications": "@{name} പോസ്റ്റുചെയ്യുന്നത് എന്നെ അറിയിക്കുന്നത് നിർത്തുക",
  "account.edit_profile": "പ്രൊഫൈൽ തിരുത്തുക",
  "account.enable_notifications": "@{name} പോസ്റ്റ് ചെയ്യുമ്പോൾ എന്നെ അറിയിക്കുക",
  "account.endorse": "പ്രൊഫൈലിൽ പ്രകടമാക്കുക",
  "account.follow": "പിന്തുടരുക",
  "account.follow_back": "തിരിച്ചു പിന്തുടരുക",
  "account.followers": "പിന്തുടരുന്നവർ",
  "account.followers.empty": "ഈ ഉപയോക്താവിനെ ആരും ഇതുവരെ പിന്തുടരുന്നില്ല.",
  "account.following": "പിന്തുടരുന്നു",
  "account.follows.empty": "ഈ ഉപയോക്താവ് ആരേയും ഇതുവരെ പിന്തുടരുന്നില്ല.",
  "account.go_to_profile": "പ്രൊഫൈലിലേക്ക് പോകാം",
  "account.hide_reblogs": "@{name} ബൂസ്റ്റ് ചെയ്തവ മറയ്കുക",
  "account.joined_short": "ജോയിൻ ചെയ്‌തിരിക്കുന്നു",
  "account.languages": "സബ്‌സ്‌ക്രൈബ് ചെയ്‌ത ഭാഷകൾ മാറ്റുക",
  "account.link_verified_on": "ഈ ലിങ്കിന്റെ ഉടമസ്തത {date} ഇൽ ഉറപ്പാക്കിയതാണ്",
  "account.locked_info": "ഈ അംഗത്വത്തിന്റെ സ്വകാര്യതാ നിലപാട് അനുസരിച്ച് പിന്തുടരുന്നവരെ തിരഞ്ഞെടുക്കാനുള്ള വിവേചനാധികാരം ഉടമസ്ഥനിൽ നിഷിപ്തമായിരിക്കുന്നു.",
  "account.media": "മീഡിയ",
  "account.mention": "@{name} സൂചിപ്പിക്കുക",
  "account.mute": "@{name}-നെ(യെ) നിശ്ശബ്ദമാക്കൂ",
  "account.mute_notifications_short": "അറിയിപ്പുകൾ മിണ്ടാതാക്കുക",
  "account.mute_short": "മിണ്ടാതാക്കുക",
  "account.muted": "നിശ്ശബ്ദമാക്കിയിരിക്കുന്നു",
  "account.no_bio": "വിവരണം നല്കുിയിട്ടില്ല.",
  "account.open_original_page": "ആദ്യത്തു് താൾ തുറക്കുക",
  "account.posts": "പോസ്റ്റുകൾ",
  "account.report": "റിപ്പോർട്ട് ചെയ്യുക @{name}",
  "account.share": "@{name} ന്റെ പ്രൊഫൈൽ പങ്കിടുക",
  "account.show_reblogs": "@{name} ൽ നിന്നുള്ള ബൂസ്റ്റുകൾ കാണിക്കുക",
  "account.unblock": "@{name} തടഞ്ഞത് മാറ്റുക",
  "account.unblock_domain": "{domain} എന്ന മേഖല വെളിപ്പെടുത്തുക",
  "account.unblock_short": "അൺബ്ലോക്കു ചെയ്യുക",
  "account.unendorse": "പ്രൊഫൈലിൽ പ്രകടമാക്കരുത്",
  "account.unfollow": "പിന്തുടരുന്നത് നിര്‍ത്തുക",
  "account.unmute": "നിശ്ശബ്ദമാക്കുന്നത് നിർത്തുക @{name}",
  "account.unmute_short": "അൺമ്യൂട്ട് ചെയ്യുക",
  "account_note.placeholder": "കുറിപ്പ് ചേർക്കാൻ ക്ലിക്കുചെയ്യുക",
  "admin.dashboard.retention.average": "ശരാശരി",
  "admin.dashboard.retention.cohort_size": "പുതിയ ഉപയോക്താക്കൾ",
  "alert.rate_limited.message": "{retry_time, time, medium} നു ശേഷം വീണ്ടും ശ്രമിക്കുക.",
  "alert.rate_limited.title": "തോത് പരിമിതപ്പെടുത്തിയിരിക്കുന്നു",
  "alert.unexpected.message": "അപ്രതീക്ഷിതമായി എന്തോ സംഭവിച്ചു.",
  "alert.unexpected.title": "ശ്ശോ!",
  "alt_text_badge.title": "പകരമായ വരി",
  "announcement.announcement": "അറിയിപ്പ്",
  "attachments_list.unprocessed": "(പ്രോസസ്സ് ചെയ്യാത്തത്)",
  "audio.hide": "ശബ്ദം ഒഴിവാക്കുക",
  "block_modal.show_less": "കുറച്ചു് കാണിക്കുക",
  "block_modal.show_more": "ഇനിയും കാണിക്കുക",
  "block_modal.title": "ഉപയോക്താവിനു് തടസ്സപെടുത്തുക?",
  "boost_modal.combo": "അടുത്ത തവണ ഇത് ഒഴിവാക്കുവാൻ {combo} ഞെക്കാവുന്നതാണ്",
  "bundle_column_error.copy_stacktrace": "പിഴരേഖ പകർത്തുക",
  "bundle_column_error.error.title": "അയ്യോ!",
  "bundle_column_error.network.title": "നെറ്റ്‍വർക്ക് പിശക്",
  "bundle_column_error.retry": "വീണ്ടും ശ്രമിക്കുക",
  "bundle_column_error.return": "ഹോം പേജിലേക്ക് മടങ്ങാം",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "അടയ്ക്കുക",
  "bundle_modal_error.retry": "വീണ്ടും ശ്രമിക്കുക",
  "closed_registrations.other_server_instructions": "Mastodon വികേന്ദ്രീകൃത സംവിധാനം ആയതിനാൽ, നിങ്ങൾക്ക് മറ്റൊരു സെർവറിൽ ഒരു അക്കൗണ്ട് ഉണ്ടാക്കിയും ഇതുമായി ആശയവിനിമയം നടത്താൻ സാധിക്കുന്നതാണ്.",
  "closed_registrations_modal.description": "{domain} ഇൽ ഇപ്പോൾ അക്കൗണ്ട് ഉണ്ടാക്കാൻ സാധിക്കുന്നതല്ല, Mastodon ഉപയോഗിക്കുന്നതിനായി നിങ്ങൾക്ക് {domain}-ൽ പ്രത്യേകമായി ഒരു അക്കൗണ്ട് ആവശ്യമില്ല എന്നത് ദയവായി ഓർക്കുക.",
  "closed_registrations_modal.find_another_server": "മറ്റൊരു സെർവർ കണ്ടെത്തുക",
  "closed_registrations_modal.title": "മാസ്റ്റഡോണിൽ ചേർക്കൽ",
  "column.about": "അപ്ലിക്കേഷനെക്കുറിച്ച്",
  "column.blocks": "തടയപ്പെട്ട ഉപയോക്താക്കൾ",
  "column.bookmarks": "ബുക്ക്മാർക്കുകൾ",
  "column.community": "പ്രാദേശികമായ സമയരേഖ",
  "column.directory": "പ്രൊഫൈലുകൾ മറിച്ചുനോക്കുക",
  "column.domain_blocks": "മറയ്ക്കപ്പെട്ട മേഖലകൾ",
  "column.favourites": "പ്രിയപ്പെട്ടതു്",
  "column.follow_requests": "പിന്തുടരാനുള്ള അഭ്യർത്ഥനകൾ",
  "column.home": "ആമുഖം",
  "column.lists": "പട്ടികകൾ",
  "column.mutes": "നിശബ്ദമാക്കപ്പെട്ട ഉപയോക്താക്കൾ",
  "column.notifications": "അറിയിപ്പുകൾ",
  "column.pins": "ഉറപ്പിച്ചു നിറുത്തിയിരിക്കുന്ന ടൂട്ടുകൾ",
  "column.public": "സംയുക്തമായ സമയരേഖ",
  "column_back_button.label": "പുറകിലേക്ക്",
  "column_header.hide_settings": "ക്രമീകരണങ്ങൾ മറയ്ക്കുക",
  "column_header.moveLeft_settings": "എഴുത്തുപംക്തി ഇടത്തോട്ട് മാറ്റുക",
  "column_header.moveRight_settings": "എഴുത്തുപംക്തി വലത്തോട്ട് മാറ്റുക",
  "column_header.pin": "ഉറപ്പിച്ചു നിറുത്തുക",
  "column_header.show_settings": "ക്രമീകരണങ്ങൾ കാണിക്കുക",
  "column_header.unpin": "ഇളക്കി മാറ്റുക",
  "community.column_settings.local_only": "പ്രാദേശികം മാത്രം",
  "community.column_settings.media_only": "മാധ്യമങ്ങൾ മാത്രം",
  "community.column_settings.remote_only": "വിദൂര മാത്രം",
  "compose.language.change": "ഭാഷ മാറ്റുക",
  "compose.language.search": "ഭാഷകൾ തിരയുക...",
  "compose.published.open": "തുറക്കുക",
  "compose_form.direct_message_warning_learn_more": "കൂടുതൽ പഠിക്കുക",
  "compose_form.encryption_warning": "Mastodon-ലെ പോസ്റ്റുകൾ എൻഡ്-ടു-എൻഡ് എൻക്രിപ്റ്റ് ചെയ്തവയല്ല. അതിനാൽ Mastodon-ൽ പ്രധാനപ്പെട്ട വിവരങ്ങളൊന്നും പങ്കിടരുത്.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
  "compose_form.lock_disclaimer.lock": "ലോക്കുചെയ്തു",
  "compose_form.placeholder": "നിങ്ങളുടെ മനസ്സിൽ എന്താണ്?",
  "compose_form.poll.duration": "തിരഞ്ഞെടുപ്പിന്റെ സമയദൈർഖ്യം",
  "compose_form.poll.multiple": "ഒരുപാടു് സാധ്യതകൾ",
  "compose_form.poll.option_placeholder": "സാധ്യത {number}",
  "compose_form.poll.single": "ഒറ്റ സാധ്യത",
  "compose_form.poll.switch_to_multiple": "വോട്ടെടുപ്പിൽ ഒന്നിലധികം ചോയ്‌സുകൾ ഉൾപ്പെടുതുക",
  "compose_form.poll.switch_to_single": "വോട്ടെടുപ്പിൽ ഒരൊറ്റ ചോയ്‌സ്‌ മാത്രം ആക്കുക",
  "compose_form.poll.type": "രീതി",
  "compose_form.publish": "അയക്കുക",
  "compose_form.reply": "മറുപടി",
  "compose_form.save_changes": "കാലാനുസ്യതമാക്കുക",
  "compose_form.spoiler.marked": "എഴുത്ത് മുന്നറിയിപ്പിനാൽ മറച്ചിരിക്കുന്നു",
  "compose_form.spoiler.unmarked": "എഴുത്ത് മറയ്ക്കപ്പെട്ടിട്ടില്ല",
  "confirmation_modal.cancel": "റദ്ദാക്കുക",
  "confirmations.block.confirm": "തടയുക",
  "confirmations.delete.confirm": "മായ്ക്കുക",
  "confirmations.delete.message": "ഈ ടൂട്ട് ഇല്ലാതാക്കണം എന്ന് നിങ്ങൾക്ക് ഉറപ്പാണോ?",
  "confirmations.delete.title": "എഴുത്തുൾ മായ്ക്കുക?",
  "confirmations.delete_list.confirm": "മായ്ക്കുക",
  "confirmations.delete_list.message": "ഈ പട്ടിക എന്നെന്നേക്കുമായി നീക്കം ചെയ്യാൻ നിങ്ങൾ ആഗ്രഹിക്കുന്നുണ്ടോ?",
  "confirmations.delete_list.title": "പട്ടിക കളയുണോ?",
  "confirmations.discard_edit_media.confirm": "കളയുക",
  "confirmations.logout.confirm": "പുറത്തുകടക്കുക",
  "confirmations.logout.message": "നിങ്ങൾക്ക് ലോഗ് ഔട്ട് ചെയ്യണമെന്ന് ഉറപ്പാണോ?",
  "confirmations.logout.title": "പുറത്തിറങ്ങുക?",
  "confirmations.mute.confirm": "നിശ്ശബ്ദമാക്കുക",
  "confirmations.redraft.confirm": "മായിച്ച് മാറ്റങ്ങൾ വരുത്തി വീണ്ടും എഴുതുക",
  "confirmations.unfollow.confirm": "പിന്തുടരുന്നത് നിര്‍ത്തുക",
  "conversation.delete": "സംഭാഷണം മായിക്കുക",
  "conversation.mark_as_read": "വായിച്ചതായി അടയാളപ്പെടുത്തുക",
  "conversation.open": "സംഭാഷണം കാണുക",
  "conversation.with": "{names} കൂടെ",
  "copypaste.copied": "പകർത്തി",
  "directory.federated": "അറിയപ്പെടുന്ന ഫെഡിവേഴ്‌സ്ൽ നിന്ന്",
  "directory.local": "{domain} ൽ നിന്ന് മാത്രം",
  "directory.new_arrivals": "പുതിയ വരവുകൾ",
  "directory.recently_active": "അടുത്തിടെയായി സജീവമായ",
  "disabled_account_banner.account_settings": "ഇടപാടു് ക്രമീകരങ്ങൾ",
  "disabled_account_banner.text": "നിങ്ങളുടെ {disabledAccount} എന്ന അക്കൗണ്ട് ഇപ്പോൾ പ്രവർത്തനരഹിതമാണ്.",
  "domain_block_modal.title": "മേഖല തടസ്സപെടുത്തുക?",
  "domain_pill.username": "ഉപയോക്തൃപേരു്",
  "embed.instructions": "ചുവടെയുള്ള കോഡ് പകർത്തിക്കൊണ്ട് നിങ്ങളുടെ വെബ്‌സൈറ്റിൽ ഈ ടൂട്ട് ഉൾച്ചേർക്കുക.",
  "embed.preview": "ഇത് ഇങ്ങനെ കാണപ്പെടും:",
  "emoji_button.activity": "പ്രവര്‍ത്തനം",
  "emoji_button.custom": "സ്വന്തമായ ഭേദഗതി",
  "emoji_button.flags": "കൊടികൾ",
  "emoji_button.food": "ഭക്ഷണവും പാനീയവും",
  "emoji_button.label": "ഇമോജി ചേർക്കുക",
  "emoji_button.nature": "പ്രകൃതി",
  "emoji_button.not_found": "ഇമോജി പാടില്ല (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "വസ്തുക്കൾ",
  "emoji_button.people": "ആളുകൾ",
  "emoji_button.recent": "അടിക്കടി ഉപയോഗിക്കുന്നവ",
  "emoji_button.search": "തിരയുക...",
  "emoji_button.search_results": "തിരച്ചിൽ ഫലങ്ങൾ",
  "emoji_button.symbols": "ചിഹ്നങ്ങൾ",
  "emoji_button.travel": "യാത്രയും സ്ഥലങ്ങളും",
  "empty_column.account_suspended": "അക്കൗണ്ട് താൽക്കാലികമായി നിർത്തിവച്ചു",
  "empty_column.account_timeline": "ഇവിടെ ടൂട്ടുകൾ ഇല്ല!",
  "empty_column.account_unavailable": "പ്രൊഫൈൽ ലഭ്യമല്ല",
  "empty_column.blocks": "നിങ്ങൾ ഇതുവരെ ഒരു ഉപയോക്താക്കളെയും തടഞ്ഞിട്ടില്ല.",
  "empty_column.bookmarked_statuses": "നിങ്ങൾക് ഇതുവരെ അടയാളപ്പെടുത്തിയ ടൂട്ടുകൾ ഇല്ല. അടയാളപ്പെടുത്തിയാൽ അത് ഇവിടെ വരും.",
  "empty_column.community": "പ്രാദേശികമായ സമയരേഖ ശൂന്യമാണ്. എന്തെങ്കിലും പരസ്യമായി എഴുതി തുടക്കം കുറിക്കു!",
  "empty_column.domain_blocks": "മറയ്ക്കപ്പെട്ടിരിക്കുന്ന മേഖലകൾ ഇതുവരെ ഇല്ല.",
  "empty_column.hashtag": "ഈ ഹാഷ്‌ടാഗിൽ ഇതുവരെ ഒന്നുമില്ല.",
  "empty_column.home": "Your home timeline is empty! Follow more people to fill it up. {suggestions}",
  "empty_column.list": "There is nothing in this list yet. When members of this list post new statuses, they will appear here.",
  "empty_column.mutes": "നിങ്ങൾ ഇതുവരെ ഒരു ഉപയോക്താക്കളെയും തടഞ്ഞിട്ടില്ല.",
  "empty_column.notifications": "നിങ്ങൾക്ക് ഇതുവരെ ഒരു അറിയിപ്പുകളും ഇല്ല. മറ്റുള്ളവരുമായി ഇടപെട്ട് സംഭാഷണത്തിന് തുടക്കം കുറിക്കു.",
  "empty_column.public": "ഇവിടെ ഒന്നുമില്ലല്ലോ! ഇവിടെ നിറയ്ക്കാൻ എന്തെങ്കിലും പരസ്യമായി എഴുതുകയോ മറ്റ് ഉപഭോക്താക്കളെ പിന്തുടരുകയോ ചെയ്യുക",
  "errors.unexpected_crash.report_issue": "പ്രശ്നം അറിയിക്കുക",
  "explore.suggested_follows": "ആൾക്കാർ",
  "explore.trending_links": "വാര്‍ത്ത",
  "explore.trending_statuses": "എഴുത്തുകൾ",
  "explore.trending_tags": "ചർച്ചാവിഷയങ്ങൾ",
  "filter_modal.added.review_and_configure_title": "അരിക്കൽ ക്രമീകരങ്ങൾ",
  "filter_modal.select_filter.prompt_new": "പുതിയ വിഭാഗം: {name}",
  "filter_modal.select_filter.search": "തിരയുക അല്ലെങ്കിൽ നിർമാണിക്കുക",
  "firehose.all": "എല്ലാം",
  "follow_request.authorize": "ചുമതലപ്പെടുത്തുക",
  "follow_request.reject": "നിരസിക്കുക",
  "follow_suggestions.dismiss": "വീണ്ടും കാണിക്കരുതു്",
  "follow_suggestions.view_all": "എല്ലാം കാണുക",
  "follow_suggestions.who_to_follow": "ആരേ പിന്തുടരണം",
  "followed_tags": "പിന്തുടരിയതു് ചർച്ചാവിഷയങ്ങൾ",
  "footer.directory": "രൂപരേഖ നാമഗൃഹസൂചി",
  "footer.get_app": "ഉപകരണം ലഭിക്കൂ",
  "footer.privacy_policy": "സ്വകാര്യത്തനയം",
  "footer.source_code": "ഉറവിടസങ്കേതം കാണുക",
  "footer.status": "അവസ്ഥ",
  "generic.saved": "സംരക്ഷിച്ചു",
  "getting_started.heading": "തുടക്കം കുറിക്കുക",
  "hashtag.column_header.tag_mode.all": "{additional} ഉം കൂടെ",
  "hashtag.column_header.tag_mode.any": "അല്ലെങ്കിൽ {additional}",
  "hashtag.column_header.tag_mode.none": "{additional} ഇല്ലാതെ",
  "hashtag.column_settings.select.no_options_message": "ഒരു സൂചനയും കണ്ടെത്തിയില്ല",
  "hashtag.column_settings.select.placeholder": "ഹാഷ്ടാഗുകൾ എഴുതുക…",
  "hashtag.column_settings.tag_mode.all": "ഇവയെല്ലാം",
  "hashtag.column_settings.tag_mode.any": "ഇവയിലേതെങ്കിലും",
  "hashtag.column_settings.tag_mode.none": "ഇതിലൊന്നുമല്ല",
  "hashtag.column_settings.tag_toggle": "ഈ എഴുത്തുപംക്തിക്ക് കൂടുതൽ ഉപനാമങ്ങൾ ചേർക്കുക",
  "hashtag.follow": "ചർച്ചാവിഷയം പിന്തുടരുക",
  "hashtag.unfollow": "ചർച്ചാവിഷയം പിന്തുടരരുതു്",
  "home.column_settings.show_reblogs": "ബൂസ്റ്റുകൾ കാണിക്കുക",
  "home.column_settings.show_replies": "മറുപടികൾ കാണിക്കുക",
  "home.hide_announcements": "പ്രഖ്യാപനങ്ങൾ മറയ്‌ക്കുക",
  "home.pending_critical_update.link": "പുതുകൾ കാണുക",
  "home.show_announcements": "പ്രഖ്യാപനങ്ങൾ കാണിക്കുക",
  "interaction_modal.on_this_server": "ഈ സെർവറീൽ",
  "keyboard_shortcuts.back": "തിരികെ പോകുക",
  "keyboard_shortcuts.blocked": "to open blocked users list",
  "keyboard_shortcuts.boost": "ബൂസ്റ്റ് ചെയ്യുക",
  "keyboard_shortcuts.column": "to focus a status in one of the columns",
  "keyboard_shortcuts.compose": "to focus the compose textarea",
  "keyboard_shortcuts.description": "വിവരണം",
  "keyboard_shortcuts.down": "to move down in the list",
  "keyboard_shortcuts.enter": "ടൂട്ട് എടുക്കാൻ",
  "keyboard_shortcuts.federated": "to open federated timeline",
  "keyboard_shortcuts.heading": "കീബോർഡ് എളുപ്പവഴികൾ",
  "keyboard_shortcuts.home": "ആമുഖം സമയരേഖ തുറക്കുക",
  "keyboard_shortcuts.legend": "to display this legend",
  "keyboard_shortcuts.local": "പ്രാദേശിക സമയരേഖ തുറക്കാൻ",
  "keyboard_shortcuts.mention": "രചയിതാവിനെ സൂചിപ്പിക്കാൻ",
  "keyboard_shortcuts.muted": "to open muted users list",
  "keyboard_shortcuts.my_profile": "നിങ്ങളുടെ പ്രൊഫൈൽ തുറക്കാൻ",
  "keyboard_shortcuts.notifications": "to open notifications column",
  "keyboard_shortcuts.open_media": "മീഡിയ തുറക്കാൻ",
  "keyboard_shortcuts.pinned": "to open pinned toots list",
  "keyboard_shortcuts.profile": "രചയിതാവിന്റെ പ്രൊഫൈൽ തുറക്കുന്നതിന്",
  "keyboard_shortcuts.reply": "മറുപടി അയക്കാൻ",
  "keyboard_shortcuts.requests": "to open follow requests list",
  "keyboard_shortcuts.search": "തിരയൽ ഫോക്കസ് ചെയ്യുന്നതിന്",
  "keyboard_shortcuts.spoilers": "CW ഫീൽഡ് കാണിക്കാൻ/മറയ്ക്കാൻ",
  "keyboard_shortcuts.start": "to open \"get started\" column",
  "keyboard_shortcuts.toggle_hidden": "to show/hide text behind CW",
  "keyboard_shortcuts.toggle_sensitivity": "മീഡിയ കാണിക്കുന്നതിനും/മറയ്ക്കുന്നതിനും",
  "keyboard_shortcuts.toot": "ഒരു പുതിയ ടൂട്ട് ആരംഭിക്കാൻ",
  "keyboard_shortcuts.unfocus": "to un-focus compose textarea/search",
  "keyboard_shortcuts.up": "to move up in the list",
  "lightbox.close": "അടയ്ക്കുക",
  "lightbox.next": "അടുത്തത്",
  "lightbox.previous": "പുറകോട്ട്",
  "limited_account_hint.action": "എന്നാലും രൂപരേഖ കാണിക്കുക",
  "link_preview.author": "{name}-നിന്നു്",
  "lists.delete": "പട്ടിക ഒഴിവാക്കുക",
  "lists.edit": "പട്ടിക തിരുത്തുക",
  "lists.replies_policy.none": "ആരുമില്ല",
  "media_gallery.hide": "മറയ്ക്കുക",
  "navigation_bar.blocks": "തടയപ്പെട്ട ഉപയോക്താക്കൾ",
  "navigation_bar.bookmarks": "ബുക്ക്മാർക്കുകൾ",
  "navigation_bar.domain_blocks": "Hidden domains",
  "navigation_bar.favourites": "പ്രിയപ്പെട്ടതു്",
  "navigation_bar.follow_requests": "പിന്തുടരാനുള്ള അഭ്യർത്ഥനകൾ",
  "navigation_bar.lists": "ലിസ്റ്റുകൾ",
  "navigation_bar.logout": "ലോഗൗട്ട്",
  "navigation_bar.mutes": "നിശബ്ദമാക്കപ്പെട്ട ഉപയോക്താക്കൾ",
  "navigation_bar.preferences": "ക്രമീകരണങ്ങൾ",
  "navigation_bar.search": "തിരയുക",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.follow": "{name} നിങ്ങളെ പിന്തുടർന്നു",
  "notification.follow_request": "{name} നിങ്ങളെ പിന്തുടരാൻ അഭ്യർത്ഥിച്ചു",
  "notification.label.reply": "മറുപടി",
  "notification.moderation-warning.learn_more": "ഇനീം അറിയുക",
  "notification.moderation_warning.action_silence": "താങ്ങളുടെ ഇടപാടു് പരിധിപെട്ടിരിക്കുന്നു.",
  "notification.own_poll": "നിങ്ങളുടെ പോൾ അവസാനിച്ചു",
  "notification.reblog": "{name} നിങ്ങളുടെ പോസ്റ്റ് ബൂസ്റ്റ് ചെയ്തു",
  "notification.status": "{name} ഇപ്പോൾ പോസ്റ്റുചെയ്‌തു",
  "notification_requests.accept": "സ്വീകരിക്കുക",
  "notification_requests.edit_selection": "പരിഷ്കരിക്കുക",
  "notifications.clear": "അറിയിപ്പ് മായ്ക്കുക",
  "notifications.clear_confirmation": "നിങ്ങളുടെ എല്ലാ അറിയിപ്പുകളും ശാശ്വതമായി മായ്‌ക്കണമെന്ന് നിങ്ങൾക്ക് ഉറപ്പാണോ?",
  "notifications.column_settings.alert": "ഡെസ്ക്ടോപ്പ് അറിയിപ്പുകൾ",
  "notifications.column_settings.follow": "പുതിയ പിന്തുടരുന്നവർ:",
  "notifications.column_settings.follow_request": "പുതിയ പിന്തുടരൽ അഭ്യർത്ഥനകൾ:",
  "notifications.column_settings.group": "കൂട്ടം",
  "notifications.column_settings.mention": "സൂചനകൾ:",
  "notifications.column_settings.poll": "പോൾ ഫലങ്ങൾ:",
  "notifications.column_settings.push": "പുഷ് അറിയിപ്പുകൾ",
  "notifications.column_settings.reblog": "ബൂസ്റ്റുകൾ:",
  "notifications.column_settings.show": "എഴുത്തുപംക്തിയിൽ കാണിക്കുക",
  "notifications.column_settings.sound": "ശബ്ദം പ്ലേ ചെയ്യുക",
  "notifications.column_settings.status": "പുതിയ ടൂട്ടുകൾ:",
  "notifications.column_settings.update": "പരിഷ്കരണങ്ങൾ:",
  "notifications.filter.all": "എല്ലാം",
  "notifications.filter.boosts": "ബൂസ്റ്റുകൾ",
  "notifications.filter.follows": "പിന്തുടരുന്നു",
  "notifications.filter.mentions": "സൂചനകൾ",
  "notifications.filter.polls": "പോൾ ഫലങ്ങൾ",
  "notifications.filter.statuses": "നിങ്ങൾ പിന്തുടരുന്ന ആളുകളിൽ നിന്നുള്ള അപ്‌ഡേറ്റുകൾ",
  "notifications.grant_permission": "അനുമതി നൽകുക.",
  "notifications.group": "{count} അറിയിപ്പുകൾ",
  "notifications.mark_as_read": "എല്ലാ അറിയിപ്പുകളും വായിച്ചതായി അടയാളപ്പെടുത്തുക",
  "notifications.policy.filter": "അരിക്കൽ",
  "notifications.policy.filter_new_accounts_title": "പുതിയ ഇടപാടുകൾ",
  "notifications.policy.filter_not_followers_title": "താങ്ങളെ പിന്തുടരാത്തതു് ആൾക്കാർ",
  "notifications_permission_banner.enable": "ഡെസ്ക്ടോപ്പ് അറിയിപ്പുകൾ പ്രാപ്തമാക്കുക",
  "picture_in_picture.restore": "തിരികെ വയ്ക്കുക",
  "poll.closed": "അടച്ചു",
  "poll.refresh": "പുതുക്കുക",
  "poll.reveal": "ഫലങ്ങൾ കാണുക",
  "poll.vote": "വോട്ട് ചെയ്യുക",
  "poll.voted": "ഈ ഉത്തരത്തിനായി നിങ്ങൾ വോട്ട് ചെയ്തു",
  "poll_button.add_poll": "ഒരു പോൾ ചേർക്കുക",
  "poll_button.remove_poll": "പോൾ നീക്കംചെയ്യുക",
  "privacy.change": "ടൂട്ട് സ്വകാര്യത ക്രമീകരിക്കുക",
  "privacy.private.long": "താങ്ങളെ പിന്തുടരുന്നവർ മാത്രം",
  "privacy.private.short": "പിന്തുടരുന്നവർ",
  "privacy.public.short": "എല്ലാവര്‍ക്കും",
  "privacy_policy.title": "സ്വകാര്യത്തനയം",
  "refresh": "പുതുക്കുക",
  "relative_time.days": "{number}ദിവസം",
  "relative_time.full.just_now": "ഇപ്പോൾതന്നെ",
  "relative_time.hours": "{number}മണി",
  "relative_time.just_now": "ഇപ്പോൾ",
  "relative_time.today": "ഇന്ന്",
  "reply_indicator.cancel": "റദ്ദാക്കുക",
  "report.block": "തടസ്സപെടുത്തുക",
  "report.category.title_account": "രൂപരേഖ",
  "report.close": "ചെയ്തു",
  "report.forward_hint": "ഈ അക്കൗണ്ട് മറ്റൊരു സെർവറിൽ നിന്നാണ്. റിപ്പോർട്ടിന്റെ അജ്ഞാത പകർപ്പ് അവിടെ അയയ്ക്കണോ?",
  "report.next": "അടുത്തതു്",
  "report.placeholder": "കൂടുതൽ അഭിപ്രായങ്ങൾ",
  "report.reasons.spam": "ഇതു് പാഴടക്കമാണു്",
  "report.submit": "സമർപ്പിക്കുക",
  "report.target": "Report {target}",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "search.placeholder": "തിരയുക",
  "search_results.hashtags": "ഹാഷ്ടാഗുകൾ",
  "search_results.statuses": "ടൂട്ടുകൾ",
  "sign_in_banner.sign_in": "Sign in",
  "status.admin_status": "Open this status in the moderation interface",
  "status.block": "@{name} -നെ തടയുക",
  "status.bookmark": "ബുക്ക്മാർക്ക്",
  "status.cannot_reblog": "ഈ പോസ്റ്റ് ബൂസ്റ്ചെയ്യാൻ കഴിയില്ല",
  "status.copy": "ടൂട്ടിലേക്ക് ലിങ്ക് പകർത്തുക",
  "status.delete": "മായ്ക്കുക",
  "status.detailed_status": "വിശദമായ സംഭാഷണ കാഴ്‌ച",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.load_more": "കൂടുതൽ ലോഡു ചെയ്യുക",
  "status.media_hidden": "മീഡിയ മറച്ചു",
  "status.mention": "@{name} സൂചിപ്പിക്കുക",
  "status.more": "കൂടുതൽ",
  "status.mute": "@{name}-നെ നിശ്ശബ്ദമാക്കുക",
  "status.open": "Expand this status",
  "status.pin": "പ്രൊഫൈലിൽ പിൻ ചെയ്യൂ",
  "status.read_more": "കൂടുതൽ വായിക്കുക",
  "status.reblog": "ബൂസ്റ്റ്",
  "status.reblogged_by": "{name} ബൂസ്റ്റ് ചെയ്തു",
  "status.reblogs.empty": "No one has boosted this toot yet. When someone does, they will show up here.",
  "status.redraft": "ഇല്ലാതാക്കുക & വീണ്ടും ഡ്രാഫ്റ്റ് ചെയ്യുക",
  "status.remove_bookmark": "ബുക്ക്മാർക്ക് നീക്കംചെയ്യുക",
  "status.reply": "മറുപടി",
  "status.report": "@{name}--നെ റിപ്പോർട്ട് ചെയ്യുക",
  "status.share": "പങ്കിടുക",
  "status.show_more_all": "എല്ലാവർക്കുമായി കൂടുതൽ കാണിക്കുക",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "tabs_bar.home": "ആമുഖം",
  "tabs_bar.notifications": "അറിയിപ്പുകൾ",
  "time_remaining.days": "{number, plural, one {# ദിവസം} other {# ദിവസങ്ങൾ}} ബാക്കി",
  "time_remaining.hours": "{number, plural, one {# മണിക്കൂർ} other {# മണിക്കൂർ}} ശേഷിക്കുന്നു",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "trends.trending_now": "ഇപ്പോൾ ട്രെൻഡിംഗ്",
  "units.short.million": "{count}ദശലക്ഷം",
  "upload_area.title": "അപ്‌ലോഡുചെയ്യാൻ വലിച്ചിടുക",
  "upload_button.label": "ഇമേജുകൾ, ഒരു വീഡിയോ അല്ലെങ്കിൽ ഓഡിയോ ഫയൽ ചേർക്കുക",
  "upload_error.limit": "ഫയൽ അപ്‌ലോഡ് പരിധി കവിഞ്ഞു.",
  "upload_form.edit": "തിരുത്തുക",
  "upload_progress.label": "Uploading…",
  "video.close": "വീഡിയോ അടയ്ക്കുക",
  "video.download": "ഫയൽ ഇറക്കുവയ്ക്കുക",
  "video.exit_fullscreen": "പൂർണ്ണ സ്ക്രീനിൽ നിന്ന് പുറത്തുകടക്കുക",
  "video.expand": "വീഡിയോ വികസപ്പിക്കൂ",
  "video.fullscreen": "പൂർണ്ണ സ്ക്രീൻ",
  "video.hide": "വീഡിയോ മറയ്ക്കുക",
  "video.pause": "താൽക്കാലികമായി നിർത്തുക",
  "video.play": "പ്ലേ"
}
